import { useWizardContext } from '@shared/hooks'
import { Button } from 'antd'
import { Add } from 'iconsax-react'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { EditAddTeam } from './EditAddTeam'

type Props = {
  broker: number
}

export const AddTeamButton = ({ broker }: Props) => {
  const { t } = useTranslation()
  const [isOpen, setIsOpen] = useState(false)

  const { refStepSix, onChangeStep, current } = useWizardContext()

  const triggerModal = () => setIsOpen((isOpen) => !isOpen)

  const onClickAddTeam = () => {
    triggerModal()

    if (current < 5) {
      onChangeStep(5)
    }
  }

  return (
    <>
      <Button
        icon={<Add />}
        type="primary"
        onClick={onClickAddTeam}
        ref={refStepSix}
      >
        {t('add_team')}
      </Button>

      <EditAddTeam
        open={isOpen}
        broker={broker}
        onCancel={triggerModal}
        onSuccess={triggerModal}
      />
    </>
  )
}
